import { render, staticRenderFns } from "./wetAveragePeriodWise.vue?vue&type=template&id=1d044542&scoped=true&"
import script from "./wetAveragePeriodWise.vue?vue&type=script&lang=js&"
export * from "./wetAveragePeriodWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d044542",
  null
  
)

export default component.exports